@if (isSubpage()) {
  <ion-header collapse="condense" mode="ios" class="ion-no-border">
    <ion-toolbar mode="ios">
      <h1 class="condensed-header-title ion-no-margin">{{ title() }}</h1>
    </ion-toolbar>
  </ion-header>
}
